import { queryOptions } from "@tanstack/react-query"
import axios from "axios"
import { CompanySchema, DataResponse } from "schema"
import { z } from "zod"

type Response = DataResponse<z.infer<typeof CompanySchema>>

const companyQueryKey = ["company"]

type Params = {
  onSuccess?: (data: Response) => void
  enabled?: boolean
}

export const companyQuery = (params?: Params) => {
  return queryOptions({
    queryKey: companyQueryKey,
    queryFn: async () => {
      const response = await axios.get<Response>(`/companies`)

      if (params?.onSuccess) {
        params.onSuccess(response.data)
      }

      return response.data.data
    },
    enabled: params?.enabled ?? true,
  })
}
